import View from './view';
export const VisuallyImpairedFormMobile = View;
